import React from "react";
import { ErrorPageWrapper } from "./ErrorPageWrapper";
import { useErrorIconSize } from "../Icons/ErrorIconSize";
import { ErrorGlobeOffIcon } from "../Icons/ErrorGlobeOffIcon";

export const UnsupportedBrowserPage = (): JSX.Element => {
    const iconSize = useErrorIconSize();
    
    return (
        <ErrorPageWrapper
            icon={<ErrorGlobeOffIcon size={iconSize}/>}
            content={<label>Dein <b>Browser</b> wird leider nicht unterstützt.</label>}
        />
    );
}